import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const envSupabaseUrl = import.meta.env.VITE_SUPABASE_URL
const envSupabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

let cachedClient: SupabaseClient | null = null
let currentSupabaseUrl = envSupabaseUrl
let currentSupabaseAnonKey = envSupabaseAnonKey

export const configureSupabaseClient = (url: string, anonKey: string) => {
  if (!url || !anonKey) {
    console.error('Supabase configuration requires both URL and anon key')
    return
  }

  if (url === currentSupabaseUrl && anonKey === currentSupabaseAnonKey && cachedClient) {
    return
  }

  currentSupabaseUrl = url
  currentSupabaseAnonKey = anonKey
  cachedClient = null
}

export const getSupabaseClient = (): SupabaseClient => {
  if (cachedClient) {
    return cachedClient
  }

  if (!currentSupabaseUrl || !currentSupabaseAnonKey) {
    throw new Error(
      'Supabase credentials are missing. Please define VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your environment.',
    )
  }

  cachedClient = createClient(currentSupabaseUrl, currentSupabaseAnonKey, {
    auth: { persistSession: false },
  })

  return cachedClient
}

export const BOOKING_IMAGE_BUCKET = 'booking-images'
